import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UrlRedirectService {
  handleInitialRedirect(): void {
    if (window.location.hash.startsWith("#/")) return;
    const urlWithoutOrigin = window.location.href.replace(
      window.location.origin,
      "",
    );
    const [path, query = ""] = urlWithoutOrigin.split("?");
    const newUrl = `${window.location.origin}/#${path}${query ? "?" + query : ""}`;

    window.location.replace(newUrl);
  }
}
